import * as React from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CopyButtonProps {
  value: string;
  children?: React.ReactNode;
  onCopied?: () => void;
  className?: string;
}

export function CopyButton({ value, children, onCopied, className }: CopyButtonProps) {
  const [copied, setCopied] = React.useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      onCopied?.();
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard API unavailable or permission denied — fail silently
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      data-copied={copied || undefined}
      onClick={handleClick}
      className={cn('h-6 w-6 shrink-0 text-muted-foreground', className)}
    >
      {copied ? <Check className="h-3.5 w-3.5 text-success" /> : <Copy className="h-3.5 w-3.5" />}
      {children}
    </Button>
  );
}
